import { Attributes, Misc, Rules, Validation, ValueObject } from '@singularsystems/neo-core';

export default class InterestRatePagedLookupCriteria extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Attributes.Nullable()
    public interestRateTypeId: number | null = null;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public rateDate: Date | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Interest Rate Paged Lookup Criteria";
    }
}